import { render, staticRenderFns } from "./LearningChart.vue?vue&type=template&id=604610ca&scoped=true"
import script from "./LearningChart.vue?vue&type=script&lang=js"
export * from "./LearningChart.vue?vue&type=script&lang=js"
import style0 from "./LearningChart.vue?vue&type=style&index=0&id=604610ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604610ca",
  null
  
)

export default component.exports